import { createFileRoute } from '@tanstack/react-router';
import { ReviewForm } from '@/components/public/ReviewForm';

export const Route = createFileRoute('/(public)/review/$reviewId/$id2')({
  component: ReviewTwoParamPage,
});

function ReviewTwoParamPage() {
  const { reviewId, id2 } = Route.useParams();
  return <ReviewForm reviewId={reviewId} id2={id2} />;
}
